import script from "./Lightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lightbox.vue?vue&type=script&setup=true&lang=ts"

export default script